import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export const useGoToAlarm = () => {
  const navigate = useNavigate();
  return React.useCallback(
    (alert) => () => {
      navigate(`/alerts/${alert.uuid}`);
    },
    [navigate]
  );
};
